import { indicationList } from '../data/input-list'

const retrieveFromBasic = indicationList.filter(indi => `${indi.group}${indi.value}` !== '9g')

// 軒威使用 
const state = {
  indicationCustomOptions: [
    { group: '9', value: 'g', text: '糞便潛血檢查陽性' },
    { group: '9', value: 'h', text: '貧血' },
    { group: '9', value: 'i', text: '體重減輕' },
    { group: '9', value: 'j', text: '血便' },
    { group: '9', value: 'k', text: '腹瀉' },
    { group: '9', value: 'l', text: '腹痛' },
    { group: '9', value: 'm', text: '排便習慣改變' },
    { group: '9', value: 'n', text: '其他' }
  ]
}
const getters = {
  getIndicationOptions: (state) => {
    return [...retrieveFromBasic, ...state.indicationCustomOptions]
  }
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}